import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import api from '../../api';
import { shopsActions } from '../../actions';
import { viewAllShopsSelector, userAddressSelector, directionModeSelector } from '../../selectors/shops';
import RequestGeolocation from '../../services/geolocation';
import LocationIcon from '../../../../images/icons/pin.svg';
import Search from '../Search/Search';
import styles from './SearchWrapper.module.sass';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';

class SearchWrapper extends React.PureComponent {
  requestGeolocation = () => {
    const {
      setUserAddress, userAddress, setSearchQuery, shopsLoadRequest,
    } = this.props;

    if (userAddress) {
      setSearchQuery(userAddress);
      shopsLoadRequest(userAddress);
      return;
    }

    RequestGeolocation().then((position) => {
      const params = [position.coords.latitude, position.coords.longitude];

      api.getAddress(params).then((response) => {
        // 204 when the coordinates don't reverse-geocode; keep the default list.
        if (!response.data) { return; }

        setUserAddress(response.data);
        setSearchQuery(response.data);
        shopsLoadRequest(response.data);
      });
    });
  };

  modeSelectorText = () => {
    const { directionMode, viewAllShops } = this.props;

    if (directionMode) { return 'Find Another Store'; }
    if (viewAllShops) { return 'Find A Store'; }
    return 'View All Stores';
  };

  modeSelectorAction = () => {
    const { toggleViewAllShops, directionMode } = this.props;
    const { mapService } = window;

    if (directionMode) {
      mapService.disableDirectionMode();
    }
    toggleViewAllShops();
  };

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.buttons}>
          <ClickableDiv className={styles['use-my-location']} onClick={this.requestGeolocation}>
            <img src={LocationIcon} alt="" />
            <span className={styles.text}>Use my location</span>
          </ClickableDiv>
          <ClickableDiv onClick={this.modeSelectorAction} className={styles.view}>
            { this.modeSelectorText() }
          </ClickableDiv>
        </div>
        <div className={styles.search}>
          <Search />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  toggleViewAllShops: () => { dispatch(shopsActions.toggleViewAllShops()); },
  setUserAddress: (userAddress) => { dispatch(shopsActions.setUserAddress(userAddress)); },
  setSearchQuery: (searchQuery) => { dispatch(shopsActions.setSearchQuery(searchQuery)); },
  shopsLoadRequest: (location) => { dispatch(shopsActions.shopsLoadRequest({ location })); },
});

const mapStateToProps = (state) => ({
  viewAllShops: viewAllShopsSelector(state),
  userAddress: userAddressSelector(state),
  directionMode: directionModeSelector(state),
});

SearchWrapper.propTypes = {
  viewAllShops: PropTypes.bool.isRequired,
  toggleViewAllShops: PropTypes.func.isRequired,
  setUserAddress: PropTypes.func.isRequired,
  userAddress: PropTypes.string,
  setSearchQuery: PropTypes.func.isRequired,
  shopsLoadRequest: PropTypes.func.isRequired,
  directionMode: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchWrapper);
